import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Page,
  Text,
} from '../../../components';
import api from '../../../utils/services';

const propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      carrierId: PropTypes.string.isRequired,
    }).isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
};

// Note: This component tests out React hooks on a non-critical component.
// Please do not use hooks until we have determined their stability
// If we do decide to use Hooks, add https://www.npmjs.com/package/eslint-plugin-react-hooks
// to help avoid any gotchas
// This note exists in ViewClient as well
export default function ViewCarrier(props) {
  const {
    match: {
      params: { carrierId },
      url: matchUrl,
    },
  } = props;

  const [carrier, setCarrier] = useState(null);
  useEffect(() => {
    api.carrier(carrierId)
      .then((carrierData) => {
        setCarrier(carrierData);
      });
  }, [carrierId]);

  let carrierMarkup = '';
  if (carrier !== null) {
    carrierMarkup = (
      <div>
        <Text>{`Bestige Carrier Id: ${carrier.id}`}</Text>
        <Text>{`Name: ${carrier.name}`}</Text>
        <Text>{`AQE Carrier Id: ${carrier.aqeCarrierId || 'No AQE Carrier Mapped'}`}</Text>
      </div>
    );
  }
  return (
    <Page
      breadcrumbs={[{ content: 'Carriers', href: '/settings/carriers' }]}
      title={carrier === null ? 'Loading...' : `${carrier.name}`}
      primaryAction={{ content: 'Edit', href: `${matchUrl}/edit` }}
    >
      {carrierMarkup}
    </Page>
  );
}

ViewCarrier.propTypes = propTypes;
